import React from "react";
import { Navigate } from "react-router-dom";
import OktaSignInWidget from "./OktaSignInWidget/OktaSignInWidget";
import { withOktaAuth } from "@okta/okta-react";
import LoffaLogoLogin from '../../assets/Loffa_Logo_Login.png';
import styles from './Login.module.css'

const VERSION_NUMBER = process.env.REACT_APP_VERSION_NUMBER;
const VERSION_DATE = process.env.REACT_APP_VERSION_DATE;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

function Login(props) {
  const onError = (err) => {
    console.error("error logging in", err);
  };

  if (props.authState == null) return null;

  return props.authState.isAuthenticated ? (
    <Navigate to={{ pathname: "/" }} />
  ) : (
    <div className={styles.login}>
      <div className={styles.loffaLogo}><img src={LoffaLogoLogin} alt="Loffa Interactive Logo" /></div>
      <OktaSignInWidget
        baseUrl={props.baseUrl}
        onError={onError}
      />
      <div className={styles.versionHeader}>
      {ENVIRONMENT} v.{VERSION_NUMBER} Released On: {VERSION_DATE}
      </div>
    </div>
  );
}

export default withOktaAuth(Login);